const escapeHtml = (text) =>
  text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

/**
 * Convierte un borrador en texto plano (con saltos de línea) en HTML simple
 * apto para el rich text editor: párrafos separados por líneas en blanco y
 * saltos de línea internos como <br>.
 *
 * @param {string} draft Texto del borrador generado por la IA.
 * @returns {string} HTML listo para usar como value del editor.
 */
export const formatDraftToHtml = (draft) => {
  if (!draft) return "";

  const normalizedDraft = String(draft).replace(/\r\n/g, "\n").trim();
  if (!normalizedDraft) return "";

  return normalizedDraft
    .split(/\n{2,}/)
    .map((paragraph) => {
      const paragraphWithBreaks = paragraph
        .split("\n")
        .map((line) => escapeHtml(line))
        .join("<br>");

      return `<p>${paragraphWithBreaks}</p>`;
    })
    .join("");
};
